module.exports = __webpack_public_path__ + "img/ChatGPT.723c40f4.png";